import { render } from "./DirectoryLayoutEditor.vue?vue&type=template&id=2f3abc50&scoped=true&ts=true"
import script from "./DirectoryLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./DirectoryLayoutEditor.vue?vue&type=script&lang=ts"

import "./DirectoryLayoutEditor.vue?vue&type=style&index=0&id=2f3abc50&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3abc50"]])

export default __exports__